import styled from "styled-components";
import { motion } from "framer-motion";
import { getToneTokens } from "../../styles/shared";

export const SecaoHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const SecaoTituloRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PastaInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surfaceAlt};
  border-radius: 10px;
  font-size: 13px;
  color: ${({ theme }) => theme.textPrimary};
  flex-wrap: wrap;

  strong {
    color: ${({ theme }) => theme.accent};
  }
`;

export const PastaNome = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
`;

export const PausarRow = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: ${({ theme }) => theme.textPrimary};
  cursor: pointer;
`;

export const AgendamentosLista = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 320px), 1fr));
  gap: 12px;
`;

export const Card = styled.article`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  position: relative;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

export const CardTitulo = styled.h3`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.textPrimary};
  flex: 1;
  min-width: 0;
  word-break: break-word;
`;

export const StatusPill = styled.span`
  ${({ theme, $tone = "default" }) => {
    const tokens = getToneTokens(theme, $tone);
    return `
      background: ${tokens.background};
      border: 1px solid ${tokens.border};
      color: ${tokens.text};
    `;
  }}
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 2px 8px;
  border-radius: 999px;
  white-space: nowrap;
`;

export const CardMeta = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.textSecondary};
  display: grid;
  gap: 3px;

  strong {
    color: ${({ theme }) => theme.textPrimary};
    font-weight: 600;
  }
`;

export const CardChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const Chip = styled.span`
  font-size: 11px;
  background: ${({ theme }) => theme.surfaceAlt};
  color: ${({ theme }) => theme.textSecondary};
  border: 1px solid ${({ theme }) => theme.border};
  padding: 2px 7px;
  border-radius: 999px;
`;

export const CardActions = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: auto;
`;

export const CardBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid ${({ theme, $primary }) => ($primary ? theme.accent : theme.border)};
  background: ${({ theme, $primary }) => ($primary ? theme.accent : theme.surface)};
  color: ${({ theme, $primary }) => ($primary ? "#ffffff" : theme.textSecondary)};

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.accent};
    color: ${({ theme, $primary }) => ($primary ? "#ffffff" : theme.accent)};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const EmptyState = styled.div`
  padding: 22px;
  text-align: center;
  border: 1px dashed ${({ theme }) => theme.border};
  border-radius: 10px;
  color: ${({ theme }) => theme.textSecondary};
  font-size: 13px;
`;

// ---------- Modal ----------

export const Overlay = styled(motion.div)`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
`;

export const Modal = styled(motion.div)`
  width: min(560px, 100%);
  max-height: 100%;
  overflow-y: auto;
  background: ${({ theme }) => theme.surface};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 16px;
  padding: 22px 24px;
  z-index: 201;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
  margin: auto;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const ModalTitulo = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.textPrimary};
`;

export const BotaoFechar = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.textSecondary};
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;

  &:hover {
    color: ${({ theme }) => theme.textPrimary};
  }
`;

export const SectionLabel = styled.div`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${({ theme }) => theme.textSecondary};
  font-weight: 600;
  margin: 14px 0 6px;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 140px), 1fr));
  gap: 10px;
`;

export const Field = styled.label`
  display: grid;
  gap: 6px;
  font-size: 12.5px;
  color: ${({ theme }) => theme.textPrimary};
`;

export const FieldLabel = styled.span`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${({ theme }) => theme.textSecondary};
  font-weight: 600;
`;

const ctrl = `
  width: 100%;
  min-height: 36px;
  border-radius: 8px;
  padding: 6px 10px;
  font: inherit;
`;

export const Input = styled.input`
  ${ctrl}
  background: ${({ theme }) => theme.surfaceAlt};
  border: 1px solid ${({ theme }) => theme.border};
  color: ${({ theme }) => theme.textPrimary};

  &:focus {
    border-color: ${({ theme }) => theme.accent};
    background: ${({ theme }) => theme.surface};
    outline: none;
  }
`;

export const Select = styled.select`
  ${ctrl}
  background: ${({ theme }) => theme.surfaceAlt};
  border: 1px solid ${({ theme }) => theme.border};
  color: ${({ theme }) => theme.textPrimary};
  cursor: pointer;

  &:focus {
    border-color: ${({ theme }) => theme.accent};
    outline: none;
  }
`;

export const CheckboxList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 180px), 1fr));
  gap: 4px;
`;


/**
 * Checkbox real, invisível e FOCÁVEL.
 *
 * O padrão anterior era `<input hidden>` + `<span onClick>`: o `hidden` tira o
 * input da ordem de tabulação, então os painéis, formatos, dias da semana e os
 * dois toggles do agendador não eram operáveis por teclado — e o mesmo gesto
 * tinha dois handlers concorrentes. Aqui o input continua na árvore de foco e
 * o `<label>` que o envolve faz o clique funcionar sozinho.
 */
export const EntradaOculta = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const CheckRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  font-size: 12.5px;
  border-radius: 6px;
  cursor: pointer;
  color: ${({ theme }) => theme.textPrimary};

  &:hover {
    background: ${({ theme }) => theme.surfaceAlt};
  }
`;

export const CheckBox = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme, $active }) => ($active ? theme.accent : theme.surface)};
  border: 1.5px solid
    ${({ theme, $active }) => ($active ? theme.accent : theme.border)};
  color: #ffffff;
  flex-shrink: 0;

  ${EntradaOculta}:focus-visible + & {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 2px;
  }
`;

export const ToggleRow = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 13px;
  color: ${({ theme }) => theme.textPrimary};
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surfaceAlt};
  cursor: pointer;
`;

export const ToggleSwitch = styled.span`
  width: 36px;
  height: 20px;
  background: ${({ theme, $on }) => ($on ? theme.accent : theme.border)};
  border-radius: 999px;
  position: relative;
  flex-shrink: 0;
  transition: background 0.18s ease;

  ${EntradaOculta}:focus-visible + & {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 2px;
  }

  &::after {
    content: "";
    position: absolute;
    top: 2px;
    left: ${({ $on }) => ($on ? "18px" : "2px")};
    width: 16px;
    height: 16px;
    background: #ffffff;
    border-radius: 50%;
    transition: left 0.18s ease;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  flex-wrap: wrap;
  margin-top: 16px;
`;

// ---------- Histórico ----------

export const HistoricoLista = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 280px;
  overflow-y: auto;
  font-size: 12.5px;
`;

export const HistoricoItem = styled.div`
  display: grid;
  grid-template-columns: 110px 1fr 80px auto;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 6px;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surfaceAlt};

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const HistoricoData = styled.span`
  color: ${({ theme }) => theme.textSecondary};
  font-variant-numeric: tabular-nums;
`;

/* Aviso de que "ocultar precos" nao alcanca PNG/JPG (capturas da tela).
   Sem ele, o gestor ligava o toggle e a imagem saia com os valores —
   direto para a pasta compartilhada, sem nenhum sinal. */
export const AvisoImagemComValores = styled.p`
  margin: 8px 0 0;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.45;
  color: var(--warning-text);
  background: var(--warning-bg);
  border: 1px solid var(--warning-border);
`;
